import { useEffect, useState } from "react";
import { useWindowWidth } from ".";

const useCustomCellProps = ({
  tableRef,
  tableWrapperRef,
  searchedText,
  editId,
  editDisabled,
  editErrors,
  isLoading,
  isValid,
  callbackFn1,
  callbackFn2,
  callbackFn3,
  callbackFn4,
  callbackFn5,
  callbackFn6
}) => {
  const [cellWidth3, setCellWidth3] = useState();
  const [cellWidth5, setCellWidth5] = useState();
  const [cellWidth7, setCellWidth7] = useState();
  const [cellWidth8, setCellWidth8] = useState();
  const [cellWidth10, setCellWidth10] = useState();

  const windowWidth = useWindowWidth();

  useEffect(() => {
    setCellWidth3(Math.floor(tableRef?.current?.offsetWidth / 3));
    setCellWidth5(Math.floor(tableRef?.current?.offsetWidth / 5));
    setCellWidth7(Math.floor(tableRef?.current?.offsetWidth / 7));
    setCellWidth8(Math.floor(tableRef?.current?.offsetWidth / 8));
    setCellWidth10(Math.floor(tableRef?.current?.offsetWidth / 10));
  }, [windowWidth, tableRef?.current?.offsetWidth]);

  return {
    cellWidth3,
    cellWidth5,
    cellWidth7,
    cellWidth8,
    cellWidth10,
    searchedText,
    editId,
    editDisabled,
    editErrors,
    isLoading,
    tableRef,
    tableWrapperRef,
    isValid,
    callbackFn1,
    callbackFn2,
    callbackFn3,
    callbackFn4,
    callbackFn5,
    callbackFn6
  };
};

export default useCustomCellProps;
